import request, { ResponseData } from "../utils/request";
import { PATH_PREFIX } from "../constants/request";
import i18next from "../i18n";

export const PREFIX = `${PATH_PREFIX}/auth/v2.1.0`;
export const GLOBAL_PREFIX = `${PATH_PREFIX}/global/v1.0.0`;

const commonParams = {
  area: i18next.language,
};

// const version_code = localStorage.getItem('version_code')
// const system_type = localStorage.getItem('system_type')

export async function mobileLogin(params: {
  mobile: string;
  sms_code?: string;
  password?: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/mobile-login`, {
    ...commonParams,
    ...params,
  });
}

// 企业登录LDAP
// req:id_token:string,sso的id_token
export async function enterprise(params: {
  id_token: string;
}): Promise<ResponseData> {
  return await request.get(`${PREFIX}/enterprise`, {
    ...commonParams,
    ...params,
  });
}

export async function sendSMSCode(mobile: string): Promise<ResponseData> {
  return await request.post(`${PREFIX}/send-sms`, {
    ...commonParams,
    mobile,
  });
}

// 注册
export async function register(params: {
  user_mobile: string;
  sms_code: string;
  password: string;
  auth_check?: boolean;
  invitations?: string[];
  name?: string;
  email?: string;
  rtype?: string;
  scale?: string;
  field?: string;
  purpose?: string;
  usage?: string;
  access?: string;
  area?: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/register${location.search}`, {
    ...commonParams,
    ...params,
  });
}

// 生成注册资格
export async function validate(params: {
  user_mobile: string;
  sms_code: string;
  password: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/validate`, {
    ...commonParams,
    ...params,
  });
}

// 实名认证
export async function verifyuser(params: {
  name: string;
  id_number: string;
  user_mobile: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/verifyuser${location.search}`, {
    ...commonParams,
    ...params,
  });
}

// 退出
export async function logout(): Promise<ResponseData> {
  return await request.post(`${PREFIX}/logout`, {
    ...commonParams,
  });
}

// 注销账号
export async function logoff(): Promise<ResponseData> {
  return await request.post(`${PREFIX}/logoff`, {
    ...commonParams,
  });
}

// 登录状态下设置密码
export async function initPassword(params: {
  password: string;
  confirm: string;
}) {
  return await request.post(`${PREFIX}/init`, {
    ...commonParams,
    ...params,
  });
}

// 登录状态下修改密码
export async function editPassword(params: {
  origin: string;
  password: string;
}) {
  return await request.post(`${PREFIX}/password-modify`, {
    ...commonParams,
    origin: params.origin,
    modify: params.password,
  });
}

// 忘记密码
export async function resetPassword(params: {
  mobile: string;
  sms_code: string;
  password: string;
  confirm: string;
}) {
  return await request.post(`${PREFIX}/password-forget`, {
    ...commonParams,
    ...params,
  });
}

// 获取用户类型，用于设置密码和区分ldap用户
export async function getUserType() {
  return await request.get(`${PREFIX}/type`, {
    ...commonParams,
  });
}

// 设置 ”对话数据用于优化模型“ 开关
export async function modifyModelSwitch(params: { model_switch: string }) {
  return await request.post(`${PREFIX}/modelswitch`, {
    ...commonParams,
    ...params,
  });
}

// app版本以及组件开关
export async function versioncheck() {
  const version_code = localStorage.getItem("version_code");
  const system_type = localStorage.getItem("system_type");
  return request.get(`${PREFIX}/versioncheck`, {
    ...commonParams,
  });
}

// 解析ip
export async function getUserIp(): Promise<ResponseData> {
  return request.get(`${PREFIX}/customeip`, {
    ...commonParams,
  });
}

// 全局组件开关
export async function getGlobalConf() {
  return await request.get(`${PREFIX}/config`, {
    ...commonParams,
  });
}

// 水印
export async function getWaterMark(): Promise<ResponseData> {
  return await request.get(`${PREFIX}/watermark`, {});
}

// 获取用户信息
export async function getUserConfig() {
  return request.get(`${PREFIX}/user-info`, {});
}

// PV
export async function pb(params: { page: string; from_url: string }) {
  return request.get(`${PREFIX}/pb`, {
    ...commonParams,
    ...params,
  });
}

// 心跳
export async function live() {
  return request.get(`${PREFIX}/live`, {});
}

export async function emailLogin(params: {
  email: string;
  email_code: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/email-login`, {
    ...commonParams,
    ...params,
  });
}

export async function getUserInfo(): Promise<ResponseData> {
  return await request.get(`${PREFIX}/user-info`, {
    ...commonParams,
  });
}

export async function getBindInfo(params: {
  Authorization: string;
}): Promise<ResponseData> {
  return await request.get(`${PREFIX}/bind-info`, {
    ...commonParams,
    ...params,
  });
}

export async function bindThirdParty(params: {
  platform: string;
  id: string;
  token: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/bind-3ty`, {
    ...commonParams,
    ...params,
  });
}

export async function unbindThirdParty(params: {
  platform: string;
  id: string;
  token: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/unbind-3ty`, {
    ...commonParams,
    ...params,
  });
}

export async function bindMobile(params: {
  mobile: string;
  sms_code: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/bind-mobile`, {
    ...commonParams,
    ...params,
  });
}

export async function unbindMobile(params: {
  mobile: string;
  sms_code: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/unbind-mobile`, {
    ...commonParams,
    ...params,
  });
}

export async function bindEmail(params: {
  email: string;
  code: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/bind-email`, {
    ...commonParams,
    ...params,
  });
}

export async function unbindEmail(params: {
  email: string;
  code: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/unbind-email`, {
    ...commonParams,
    ...params,
  });
}

export async function sendEmailCode(email: string): Promise<ResponseData> {
  return await request.post(`${PREFIX}/send-email`, {
    ...commonParams,
    email,
  });
}

export async function thirdPartyLogin(params: {
  platform: string;
  id: string;
  token: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/3ty-login`, {
    ...commonParams,
    ...params,
  });
}

// 意见反馈
export async function feedback(params: {
  feedback: string;
}): Promise<ResponseData> {
  return await request.post(`${PREFIX}/feedback`, {
    ...params,
  });
}
